import { render, staticRenderFns } from "./personStudyTrajectoryList.vue?vue&type=template&id=b4795d56"
import script from "./personStudyTrajectoryList.vue?vue&type=script&lang=js"
export * from "./personStudyTrajectoryList.vue?vue&type=script&lang=js"
import style0 from "./personStudyTrajectoryList.vue?vue&type=style&index=0&id=b4795d56&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports